import { Duration, DurationLikeObject } from 'luxon';

export class DurationUtils {
  static toHumanDuration(duration: number | Duration, maxSu = 2): string {
    if (!duration) {
      return '';
    }

    let humanDuration = '';
    let myDuration = typeof duration === 'number' ? Duration.fromMillis(duration) : duration;
    const negative = myDuration.valueOf() < 0;
    if (negative) {
      myDuration = Duration.fromMillis(0 - myDuration.valueOf());
    }
    myDuration = myDuration.shiftTo('days', 'hours', 'minutes', 'seconds', 'milliseconds');

    const days = myDuration.days;
    const hours = myDuration.hours;
    const minutes = myDuration.minutes;
    const seconds = myDuration.seconds;

    // "Significant units"
    let su = 0;

    if (su < maxSu && days !== 0) {
      humanDuration += `${days} day${days === 1 ? '' : 's'} `;
      su++;
    }
    if (su < maxSu && hours !== 0) {
      humanDuration += `${hours} hour${hours === 1 ? '' : 's'} `;
      su++;
    }
    if (su < maxSu && minutes !== 0) {
      humanDuration += `${minutes} minute${minutes === 1 ? '' : 's'} `;
      su++;
    }
    if (su < maxSu && seconds !== 0) {
      humanDuration += `${seconds} second${seconds === 1 ? '' : 's'} `;
      su++;
    }

    return (negative ? '-' : '') + humanDuration.trim();
  }

  static parseDuration(durationString: string): Duration | null {
    if (
      !durationString ||
      typeof durationString !== 'string' ||
      durationString.trim().length === 0
    ) {
      return null;
    }

    const negative = /^-\d/.test(durationString.trim());
    const regex = /((\d+)\s*([^\d\s]+)\s*)((\d+)\s*([^\d\s]+)\s*)?((\d+)\s*([^\d\s]+)\s*)?((\d+)\s*([^\d\s]+)\s*)?/;
    const split = regex.exec(durationString);
    let duration = Duration.fromMillis(0);

    if (!split) {
      return null;
    }

    for (let i = 2; i < split.length - 1; i += 3) {
      if (!split[i] || !split[i + 1]) {
        break;
      }

      const diff = this.splitToDurationLike(split.slice(i, i + 2));

      if (diff == null) return null;

      duration = negative ? duration.minus(diff) : duration.plus(diff);
    }

    return duration;
  }

  static splitToDurationLike(unitStringSplit: string[]): DurationLikeObject | null {
    const num = +unitStringSplit[0];
    const unitString = unitStringSplit[1].trim();

    if (/^[yY]/.test(unitString)) {
      return { years: num };
    }

    if (/^[mM][oO]/.test(unitString)) {
      return { months: num };
    }

    if (/^[dD]/.test(unitString)) {
      return { days: num };
    }

    if (/^[hH]/.test(unitString)) {
      return { hours: num };
    }

    if (/^[mM]/.test(unitString)) {
      return { minutes: num };
    }

    if (/^[sS]/.test(unitString)) {
      return { seconds: num };
    }

    return null;
  }
}
